import {
    FormControl, FormErrorMessage, FormLabel, HStack,
} from '@chakra-ui/react';
import {
    Control, FieldValues, Path, useController,
} from 'react-hook-form';
import { EmailOption, EmailSelect } from '../email-select/email-select';

export function EmailSelectField<TFormValues extends FieldValues>({
    control,
    name,
    label,
    options,
    isLoading,
    isCreatable = true,
    isMulti = true,
    rightComponent,
}: {
    control: Control<TFormValues>;
    name: Path<TFormValues>;
    label: string;
    options: EmailOption[];
    isLoading: boolean;
    isCreatable?: boolean;
    isMulti?: boolean;
    rightComponent?: React.ReactNode;
}) {
    const {
        field,
        fieldState: { error, invalid },
    } = useController({
        name,
        control,
    });

    return (
        <FormControl isInvalid={invalid}>
            <FormLabel>{label}</FormLabel>
            <HStack w="full">
                <EmailSelect
                    isMulti={isMulti}
                    options={options}
                    {...field}
                    isInvalid={invalid}
                    isLoading={isLoading}
                    isCreatable={isCreatable}
                />
                {rightComponent}
            </HStack>
            <FormErrorMessage>
                {error && error?.message}
            </FormErrorMessage>
        </FormControl>
    );
}
